import React from 'react';
import axios from 'axios';
import EventBus from 'eventing-bus';
import { toast } from 'react-toastify';
import { all, takeEvery, call, put } from 'redux-saga/effects';
import CustomToast from '../../components/toaster';
import 'react-toastify/dist/ReactToastify.css';
import { AlchemyUrl, env } from '../config';

function* createBurnNftRecord({ payload }) {
  const { error, response } = yield call(postCall, { path: '/bridge/createBurnNftRecord', payload });
  if (error) EventBus.publish('error', error['response']['data']['message'])
  else if (response) {
    yield put({ type: 'SET_BURN_NFT_RECORD', payload: true });
    EventBus.publish('success', response['data']['message']);
  }
};


function* mintNewNft({ payload }) {
  const { error, response } = yield call(putCall, { path: `/bridge/updateBurnNft/${payload?.tokenId}`, payload });
  if (error) EventBus.publish('error', error['response']['data']['message'])
  else if (response) {
    yield put({ type: 'SET_MINTED_NFT', payload: response.data.body });
    toast.success(<CustomToast txId={response?.data?.body?.nftTokenIdSolana} name={response?.data?.body?.nftName} />);

  }
};

function* getBurnNftHistory({ payload }) {
  const { error, response } = yield call(getCall, `/bridge/getRecords/${payload}`);
  if (error) EventBus.publish('error', error['response']['data']['message'])
  else if (response) {
    yield put({ type: 'BURN_NFT_HISTORY', payload: response.data.body })
  }
};


function* getWalletNft({ payload }) {
  const apiKey = process.env.REACT_APP_ALCHEMY_API_KEY;
  const { error, response } = yield call(getCallExternal, `${AlchemyUrl}/nft/v2/${apiKey}/getNFTs?owner=${payload}`);

  if (error) {
    EventBus.publish('error', error['response']['data']['message']);
  } else if (response) {
    let ownedNfts = response.ownedNfts;

    if (env === 'production') {
      ownedNfts = ownedNfts.filter(nft =>
        nft.contract.address.toLowerCase() === "0x87ba7eeb098d25052f4e5299e2880e97285e344f"
      );
    }

    const parsedNfts = ownedNfts.map(nft => {
      const rawImageUrl = nft.metadata?.image || "";
      const imageUrl = rawImageUrl.startsWith("ipfs://")
        ? rawImageUrl.replace("ipfs://", "https://mpc-nft.infura-ipfs.io/ipfs/")
        : rawImageUrl.replace("https://ipfs.infura.io/ipfs/", "https://mpc-nft.infura-ipfs.io/ipfs/");

      return {
        imageUrl,
        name: nft.metadata?.name,
        symbol: nft.metadata?.symbol || "MPC",
        contract: nft.contract.address,
        tokenId: nft.id.tokenId
      };
    });

    yield put({ type: 'SET_WALLET_NFT', payload: parsedNfts });
  }
}


function* actionWatcher() {
  yield takeEvery('CREATE_BURN_NFT_RECORD', createBurnNftRecord);
  yield takeEvery('MINT_NEW_NFT', mintNewNft);
  yield takeEvery('GET_BURN_NFT_HISTORY', getBurnNftHistory);
  yield takeEvery('GET_WALLET_NFT', getWalletNft);
};

export default function* rootSaga() {
  yield all([actionWatcher()]);
};

function postCall({ path, payload }) {
  return axios
    .post(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
};

function getCall(path) {
  return axios
    .get(path)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
};

function deleteCall(path) {
  return axios
    .delete(path)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
};

function putCall({ path, payload }) {
  return axios
    .put(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
};

function getCallExternal(path) {
  return fetch(path)
    .then(async (res) => {
      const data = await res.json();
      return { response: data };
    })
    .catch((error) => {
      if (error.response.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
};